import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const product = async (id?: number) => axios.get(Routes.PRODUCT + "/" + id);

export const useProduct = (id?: number) =>
  useQuery({
    queryKey: [Keys.PRODUCT_QRY, id],
    queryFn: () => product(id),
    enabled: id ? true : false,
  });
